import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { posService } from '@/services/pos.service';
import { FloatingField } from './FloatingField';
import { pickupStoreRules } from './customerFormSchema';

interface Props {
  /**
   * Nhãn nổi của ô. `FulfillmentBar` chỉ còn render component này cho `vault`
   * (đã ẩn khỏi thanh chọn, chỉ đơn khôi phục cũ còn dùng), luôn truyền "Chi
   * nhánh lưu kho" — `pickup` không còn dropdown nữa, dùng thẳng chi nhánh đang
   * bán qua Form.Item ẩn ở `FulfillmentFormSection`.
   */
  label?: string;
}

export function BranchSelectField({ label = 'Chọn chi nhánh' }: Props = {}) {
  const { data: stores, isLoading } = useQuery({
    queryKey: ['pos-my-stores'],
    queryFn: () => posService.getMyStores(),
  });

  return (
    <FloatingField className="branch-field" label={label} name="pickup_store_id" rules={pickupStoreRules} required>
      <Select
        loading={isLoading}
        placeholder="Chọn chi nhánh"
        options={(stores ?? []).map((s) => ({ label: s.name, value: s.id }))}
        showSearch
        optionFilterProp="label"
      />
    </FloatingField>
  );
}
